import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { tableConfig } from '../../../../settings';

const promoCodesApi = new Api('promo_codes');
const applyPromocodeApi = new Api('jobs/:id/promo_codes/:promoCodeId/apply');

function* loadPromoCodesData(data) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = data.payload;
    const result = yield call(
      sendRequest,
      promoCodesApi.load,
      { search: { for_job: 1, page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortableColumns } = result.data.success.data;

      yield put(
        actions.loadPromoCodesDataSuccess({
          data: records,
          totalCount,
          filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* applyPromoCode(data) {
  try {
    const { payload } = data;
    const { jobId, id } = payload;

    const result = yield call(
      sendRequest,
      applyPromocodeApi.updateItem,
      {
        data: { company: {} },
        id: [jobId, id],
      },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.saveSuccess());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.ADD_PROMOCODE, loadPromoCodesData), takeEvery(actions.PROMOCODE_SAVE, applyPromoCode)]);
}
